import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createSlots as _createSlots, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e9accabc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "inner" }
const _hoisted_2 = { class: "content-wrapper" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = ["innerHTML"]

import BaseButton from "@/components/base/BaseButton.vue";
import BaseExpansion from "@/components/base/BaseExpansion.vue";
import BaseSection from "@/components/base/BaseSection.vue";
import BaseSvg from "@/components/base/BaseSvg.vue";
import BookingExtraInnerSections from "@/components/bookingflow/steps/extras/BookingExtraInnerSections.vue";
import { Component } from "@/models/enums";
import { ExtrasComponent } from "@/models/www/ExtrasComponent";
import useVuelidate from "@vuelidate/core";
import { computed, ref, watch } from "vue";

interface Props {
  component: ExtrasComponent;
  componentIndex: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BookingExtra',
  props: {
    component: null,
    componentIndex: null
  },
  setup(__props: any) {

const props = __props as {
  component: ExtrasComponent;
  componentIndex: number;
}


const isExcessLuggage = computed(() => {
	return props.component.title === "Scillonian excess luggage";
});

const getExpandValue = computed(() => {
  if (isExcessLuggage.value === true) {
    return true;
  } else return props.component.expanded;
});

const expanded = ref<boolean>(getExpandValue.value);

const checked = computed(() => {
  return props.component.checked;
});

const displayTermCheckboxes = computed(() => {
  return (
    props.component.componentName ===
      Component[Component.BookingExtraTermsCheckboxList] &&
    expanded.value === false
  );
});

//if component is checked then collapse it
watch(checked, () => {
  if (checked.value) {
    expanded.value = false;
  }
});

const v$ = useVuelidate();

const expand = () => {
  expanded.value = !expanded.value;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseSection, {
    errors: _unref(v$).$errors
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["booking-extra", { expanded: expanded.value }])
      }, [
        _createElementVNode("div", {
          class: "header",
          onClick: expand
        }, [
          _createVNode(BaseSvg, {
            icon: __props.component.icon
          }, null, 8, ["icon"]),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("h4", null, _toDisplayString(__props.component.title), 1),
            _createElementVNode("p", null, _toDisplayString(__props.component.description), 1),
            _createVNode(BaseButton, { "aria-controls": "unique-content-id" }, {
              default: _withCtx(() => [
                _createVNode(BaseSvg, { icon: 'chevron/chevron-circle-up' })
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(BaseExpansion, {
            expanded: !expanded.value
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", null, _toDisplayString(__props.component.preview), 1)
            ]),
            _: 1
          }, 8, ["expanded"]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(BaseExpansion, { expanded: expanded.value }, _createSlots({
              default: _withCtx(() => [
                (__props.component.content)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "xhtml",
                      innerHTML: __props.component.content
                    }, null, 8, _hoisted_4))
                  : _createCommentVNode("", true),
                (!_unref(displayTermCheckboxes))
                  ? (_openBlock(), _createBlock(BookingExtraInnerSections, {
                      key: 1,
                      componentIndex: __props.componentIndex,
                      componentName: __props.component.componentName,
                      componentType: __props.component.componentType,
                      innerSections: __props.component.innerSections
                    }, null, 8, ["componentIndex", "componentName", "componentType", "innerSections"]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, [
              (_unref(displayTermCheckboxes))
                ? {
                    name: "outer",
                    fn: _withCtx(() => [
                      (_unref(displayTermCheckboxes))
                        ? (_openBlock(), _createBlock(BookingExtraInnerSections, {
                            key: 0,
                            componentIndex: __props.componentIndex,
                            componentName: __props.component.componentName,
                            innerSections: __props.component.innerSections
                          }, null, 8, ["componentIndex", "componentName", "innerSections"]))
                        : _createCommentVNode("", true)
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1032, ["expanded"])
          ])
        ])
      ], 2)
    ]),
    _: 1
  }, 8, ["errors"]))
}
}

})